import React from "react";
import { Datagrid, List, TextField, useLocaleState } from "react-admin";

const AboutList = () => {
  const [locale] = useLocaleState();

  return (
    <List pagination={false}>
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField label="about.title" source={`sectionTitle.${locale}`} />
      </Datagrid>
    </List>
  );
};

export default AboutList;
